import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { formatApiError } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const ResetPassword = () => {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) return alert("Missing reset token");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      nav("/login", { replace: true });
    } catch (err) {
      alert(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <h1 className="font-display text-2xl font-bold text-white">Choose new password</h1>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <div>
          <Label className="text-white/70">New password</Label>
          <Input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 bg-white/5 border-white/15 text-white" />
        </div>
        <Button type="submit" disabled={loading} className="w-full bg-[#D4AF37] text-black font-bold">
          {loading ? "Saving…" : "Update password"}
        </Button>
      </form>
      <p className="mt-6 text-sm text-white/50">
        <Link to="/login" className="text-[#D4AF37] hover:underline">Sign in</Link>
      </p>
    </div>
  );
};

export default ResetPassword;
